import React from "react";
import PropTypes from "prop-types";
import "./introduce.scss";


const Introduce = () => {
    const data = [
        {
            id: 1, title: 'Giới thiệu',
            text:
                <>
                    <div>Điều khoản này có hiệu lực từ ngày 01/01/2022. </div>

                    <div>Dù biết rằng bạn rất dễ bỏ qua các điều khoản dịch vụ này, nhưng chúng tôi cần phải nêu rõ trách nhiệm của chúng tôi cũng như trách nhiệm của bạn trong quá trình bạn sử dụng các dịch vụ của Map4D. </div>

                    <div>Các điều khoản này nêu rõ cách thức kinh doanh của Map4D, những điều luật mà công ty chúng tôi phải tuân thủ và một số điều mà chúng tôi luôn tin là đúng đắn. Các điều khoản dịch vụ này giúp xác định mối quan hệ giữa bạn với hệ thống Map4D khi bạn tương tác với các dịch vụ của chúng tôi. Các nội dung trình bày trong điều khoản này bao gồm: </div>

                    <div>- Trách nhiệm của chúng tôi: Đây là phần mô tả cách chúng tôi cung cấp và phát triển các dịch vụ của mình. </div>

                    <div>- Trách nhiệm của bạn: Đây là phần trình bày một số quy tắc mà bạn phải tuân thủ theo khi sử dụng các dịch vụ của chúng tôi. </div>

                    <div>- Nội dụng trong các dịch vụ của Map4D: Phần này mô tả quyền sở hữu trí tuệ đối với nội dung mà bạn thấy trong các dịch vụ của chúng tôi, bất kể nội dung đó thuộc về bạn, Map4D hay người khác. </div>

                    <div>- Trong trường hợp xảy ra vấn đề hoặc bất đồng: Phần này mô tả các quyền hợp pháp khác mà bạn có và những điều bạn nên biết trong trường hợp có người vi phạm các điều khoản này. </div>

                    <div>Việc hiểu rõ các điều khoản này rất quan trọng bởi vì bằng việc sử dụng dịch vụ của chúng tôi tức là bạn đã đồng ý với các điều khoản này. </div>
                </>
        }
    ]
    return (
        <div className='introduce'>
            {
                data.map((value, index) => {
                    return (
                        <React.Fragment key={value.id}>
                            <div className='titContent'>{value.title}</div>
                            <div className="text">
                                {value.text}
                            </div>
                        </React.Fragment>
                    )
                })
            }
        </div>
    );
};

Introduce.propTypes = {
};

export default Introduce;
